import React, { Component } from 'react';
import './index.css'

import axios from 'axios';

import NavBar from '../NavBar/';


export default class Contact extends Component {
  state = {
    submit: 'Submit'
  }


  _sendEmail = (e) => {
    e.preventDefault();
    axios.post('/api/sendmail', {
      name: this.name.value,
      email: this.email.value,
      message: this.message.value
    })
    .then((res) => {
      // console.log('Success', res)

    })
    .catch((err) => {
      throw err;
    })

    this.name.value = '';
    this.email.value = '';
    this.message.value = '';
    this.setState({
      submit: 'Sent Successfully!'
    })
    setTimeout(() => {
      this.setState({
        submit: 'Submit'
      })
    }, 2500)
  }

  render() {
    const { submit } = this.state;
    return (
      <div>
        <NavBar title="Contact Me" />
        <div className="contact-container">  
          <form id="contact" onSubmit={this._sendEmail}>
            <h3>Contact Me!</h3>
            <h4>Contact me today, and get a reply within 24 hours!</h4>
            <h4>Feedback is appreciated too!</h4>
            <fieldset>
              <input placeholder="Your Name" type="text" tabIndex="1" ref={(input) => this.name = input} required />
            </fieldset>
            <fieldset>
              <input placeholder="Your Email Address" type="email" tabIndex="2" ref={(input) => this.email = input} required />
            </fieldset>
            <fieldset>
              <textarea placeholder="Type your Message Here...." tabIndex="5" ref={(input) => this.message = input} required ></textarea>
            </fieldset>
            <fieldset>
              <button name="submit" type="submit" id="contact-submit">{submit}</button>
            </fieldset>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Contact/index.js